import { render, staticRenderFns } from "./chooseExamRegion.vue?vue&type=template&id=cef9dd0a&"
import script from "@viewJs/examRegisteation/chooseExamRegion.js?vue&type=script&lang=js&"
export * from "@viewJs/examRegisteation/chooseExamRegion.js?vue&type=script&lang=js&"
import style0 from "./chooseExamRegion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports